import type { Role } from '@/core/auth/types';

/** Starter: no plan gating. `null` means show every menu item. */
export function useEntitlementModules(_role?: Role | null, _organizationId?: string | null) {
  return { modules: null as string[] | null, isLoading: false };
}
